import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import AddToCartQuantityDialog from "./AddToCartQuantityDialog";
import { Product } from "../../types/Product";
import { BUTTON_STYLES } from "../../styles/buttonStyles";

interface AddToCartCollapseProps {
  product: Product,
  variant: any,
  onViewDetails: (e: React.MouseEvent) => void;
  quantity?: number;
  stock?: number;
}

export const AddToCartCollapse: React.FC<AddToCartCollapseProps> = ({
  product,
  variant,
  onViewDetails,
  quantity = 1,
  stock = 10,
}) => {
  const [openAddQuantityDialog, setOpenAddQuantityDialog] = useState<boolean>(false);

  const showAddQuantityDialog = () => setOpenAddQuantityDialog(true);
  
  const closeAddQuantityDialog = () => setOpenAddQuantityDialog(false);
  
  return (
    <Box sx={{ 
      width: '100%', 
      height: '95px', 
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px 10px 0px 10px',
      boxSizing: 'border-box',
      gap: '8px'
    }}>
      <Button
        variant="contained"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          showAddQuantityDialog();
        }}
        disabled={stock === 0}
        sx={{
          ...BUTTON_STYLES.primary,
          width: '100%',
          maxWidth: '66.7%',
        }}
      >
        AGREGAR AL CARRITO
      </Button>

      <Button
        variant="text"
        onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onViewDetails(e);
        }}
        sx={BUTTON_STYLES.secondary}
      >
        Ver más detalles
      </Button>
        
      {/* Dialogs */} 
      <AddToCartQuantityDialog open={openAddQuantityDialog} 
                               product={product}
                               variant={variant}
                               onClose={closeAddQuantityDialog} 
      />  
    </Box>
  );
};














